import React, { Component } from "react";
import Reveal from "./Reveal";
import ImageCarousel from "./ImageCarousel";
import PdfViewer from "./PdfViewer";

// Texte preluate cuvant cu cuvant din "Comunicat de presa" (rezultate) si
// "Descrierea proiectului" (obiectiv general). Nu reformulati fara acordul beneficiarului.
const OBIECTIV_GENERAL =
  "Consolidarea poziției pe piață a unei microîntreprinderi inovatoare. Această întreprindere va utiliza în principal resurse umane locale în domeniul serviciilor de întreținere și reparație a autovehiculelor, un domeniu competitiv identificat în Programul Regional Sud-Vest Oltenia 2021-2027.";

const REZULTATE = [
  {
    titlu: "Implementarea de tehnologii moderne",
    text: "Au fost achizitionate, receptionate si puse in functiune echipamente performante pentru service auto, care inglobeaza tehnologii de ultima generatie, printre care: spațiu de pregătire pentru operații mecanice, elevatoare electrohidraulice cu 2 coloane, elevator hidraulic service roți si elevatoare foarfeca (inclusiv pentru geometrie), aparat 3D pentru reglarea directiei, banc de redresat caroseria, statii de service pentru aer conditionat, aparat de spălat A/C, testere de diagnoza multimarca si pentru autoutilitare, set pentru citire si rescriere ECU, echipament de curatare a filtrelor de particule, compresor cu surub si uscator, aparat de sudura, aparat de tras tabla si seturi de mecanica si tinichigerie, rezervor de aer de 1000L zincat, platformă hidraulică 1000 kg, cutter plotter, carucioare de scule, aparat spalat piese manual cu jet, aparat curatat motorul, precum si un birou reglabil si un laptop cu touch. Astfel, a fost inovat fluxul tehnologic de prestare a serviciilor si a fost diversificata gama de servicii.",
  },
  {
    titlu: "Promovarea dezvoltarii durabile si a egalitatii de sanse",
    text: "Au fost create 3 locuri de munca (cel putin o persoana din categoria celor defavorizate), care vor fi mentinute pe o perioada de cel putin 3 ani de la data finalizarii perioadei de implementare.",
  },
  {
    titlu: "Dezvoltarea competentelor",
    text: "4 angajati ai societatii au participat la cursuri de formare profesionala (2 persoane la cursuri de mecanica auto si 2 persoane la cursuri de electrician auto).",
  },
  {
    titlu: "Sustenabilitate si economie circulara",
    text: "A fost achizitionat si pus in functiune un kit de panouri fotovoltaice de 30 kW, au fost obtinute certificarile ISO 9001 (managementul calitatii) si ISO 14001 (managementul mediului), iar investitia este operata cu respectarea principiilor DNSH si ale economiei circulare.",
  },
  {
    titlu: "Internationalizare",
    text: "Societatea a participat la un targ international de profil, a realizat o vizita de lucru in Germania la o firma de profil pentru modelarea afacerii si a incheiat un acord de parteneriat, in vederea extinderii pietei si a adaptarii proceselor la standardele internationale.",
  },
];

const DOCUMENTE = [
  {
    title: "Comunicat de presă",
    pdf: "/docs/comunicat-presa-finalizare-proiect.pdf",
    image: "/docs/comunicat-presa-finalizare-proiect.jpg",
    imageWebp: "/docs/comunicat-presa-finalizare-proiect.webp",
  },
  {
    title: "Descrierea proiectului",
    pdf: "/docs/descrierea-proiectului-kfy.pdf",
    image: "/docs/descrierea-proiectului-kfy.jpg",
    imageWebp: "/docs/descrierea-proiectului-kfy.webp",
  },
];

const PANOU = [
  {
    src: "/images/regio/panou-proiect-mare.jpg",
    srcWebp: "/images/regio/panou-proiect-mare.webp",
    alt: "Panoul de informare al proiectului cofinanțat de Uniunea Europeană la KFY Auto",
  },
];

class Proiect extends Component {
  constructor(props) {
    super(props);
    this.state = { panouDeschis: false, document: null };
  }

  render() {
    const rezultate = REZULTATE.map(r => (
      <li key={r.titlu}>
        <h4>{r.titlu}</h4>
        <p>{r.text}</p>
      </li>
    ));

    const documente = DOCUMENTE.map(d => (
      <button key={d.pdf} type="button" className="button" onClick={() => this.setState({ document: d })}>
        <i className="fa-solid fa-file-pdf"></i>{" " + d.title}
      </button>
    ));

    return (
      <section id="proiect-regio">
        <Reveal direction="up">
          <div className="row">
            <div className="twelve columns">
              <div className="proiect-logos">
                <picture>
                  <source srcSet="/images/regio/eu-cofinantat.webp" type="image/webp" />
                  <img src="/images/regio/eu-cofinantat.png" alt="Cofinanțat de Uniunea Europeană" width="746" height="160" loading="lazy" />
                </picture>
                <picture>
                  <source srcSet="/images/regio/guvernul-romaniei.webp" type="image/webp" />
                  <img src="/images/regio/guvernul-romaniei.png" alt="Guvernul României" width="160" height="160" loading="lazy" />
                </picture>
                <picture>
                  <source srcSet="/images/regio/regio-sv-oltenia.webp" type="image/webp" />
                  <img src="/images/regio/regio-sv-oltenia.png" alt="Regio — Programul Regional Sud-Vest Oltenia 2021-2027" width="470" height="160" loading="lazy" />
                </picture>
              </div>

              <h2>
                „Excelenta in servicii auto prin investitii in tehnologie performanta la SC KFY CAR PARTS SRL”
              </h2>
              <p className="proiect-meta">
                Beneficiar: <strong>SC KFY CAR PARTS SRL</strong> · Cod SMIS: <strong>328644</strong>
              </p>
              <p className="proiect-program">
                Cofinantat prin Programul Regional Sud-Vest Oltenia 2021-2027, Prioritatea 1 Competitivitate prin
                inovare si intreprinderi dinamice. Fond: Fondul European de Dezvoltare Regionala.
              </p>
            </div>
          </div>

          <div className="row">
            <div className="twelve columns">
              <div className="proiect-cifre">
                <div>
                  <span className="cifra">1.771.575,05 lei</span>
                  <span className="eticheta">Valoarea totală a proiectului</span>
                </div>
                <div>
                  <span className="cifra">1.138.869,67 lei</span>
                  <span className="eticheta">Valoarea cofinanțării Uniunii Europene</span>
                </div>
                <div>
                  <span className="cifra">13.05.2025 – 13.11.2026</span>
                  <span className="eticheta">Perioada de implementare</span>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="seven columns">
              <h3>Obiectivul general</h3>
              <p>{OBIECTIV_GENERAL}</p>

              <h3>Rezultatele obținute</h3>
              <ul className="proiect-rezultate">{rezultate}</ul>
            </div>

            <div className="five columns">
              <button
                type="button"
                className="proiect-panou"
                onClick={() => this.setState({ panouDeschis: true })}
                aria-label="Mărește fotografia panoului de informare"
              >
                <picture>
                  <source srcSet="/images/regio/panou-proiect.webp" type="image/webp" />
                  <img
                    src="/images/regio/panou-proiect.jpg"
                    alt="Panoul de informare al proiectului cofinanțat de Uniunea Europeană la KFY Auto"
                    width="1200"
                    height="675"
                    loading="lazy"
                  />
                </picture>
                <span className="proiect-panou-zoom" aria-hidden="true">
                  <i className="fa-solid fa-magnifying-glass-plus"></i>
                </span>
              </button>

              <div className="proiect-documente">
                <h3>Documente</h3>
                {documente}
              </div>

              <p className="proiect-contact">
                {"Autoritate de Management: Programul Regional Sud-Vest Oltenia – "}
                <a href="https://www.adroltenia.ro" target="_blank" rel="noopener noreferrer">www.adroltenia.ro</a>
              </p>
            </div>
          </div>
        </Reveal>

        <ImageCarousel
          images={PANOU}
          isOpen={this.state.panouDeschis}
          onClose={() => this.setState({ panouDeschis: false })}
        />
        <PdfViewer doc={this.state.document} onClose={() => this.setState({ document: null })} />
      </section>
    );
  }
}

export default Proiect;
